"use strict";
var GetIntrinsic = require("get-intrinsic");
var callBindBasic = require("call-bind-apply-helpers");
var $indexOf = callBindBasic([GetIntrinsic("%String.prototype.indexOf%")]);
module.exports = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = (
    /** @type {(this: unknown, ...args: unknown[]) => unknown} */
    GetIntrinsic(name, !!allowMissing)
  );
  if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
    return callBindBasic(
      /** @type {const} */
      [intrinsic]
    );
  }
  return intrinsic;
};
